import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/datasources/getSource';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

// Fetch a single source (for the edit page).
function* operation(action) {
  try {
    const res = yield call(
      axios.get,
      `${config.API_URL}/ingestion/sources/${action.payload.sourceId}`,
      { headers: getLocalUser() },
    );
    const data = res.data?.data || res.data;
    yield put(fetchSuccess(data.source || data));
  } catch (error) {
    yield put(ErrorAction(error));
    yield put(fetchFailure(error.response?.data?.error || error.message));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
